import { Controller } from "@hotwired/stimulus"
import { EditorView, basicSetup } from "codemirror"
import { python } from "@codemirror/lang-python"
import { oneDark } from "@codemirror/theme-one-dark"
import { keymap } from "@codemirror/view"
import { indentWithTab } from "@codemirror/commands"

export default class extends Controller {
  static targets = ["host"]

  connect() {
    const initialCode = document.getElementById("initial-code")?.value || ""

    this._view = new EditorView({
      doc: initialCode,
      extensions: [
        basicSetup,
        python(),
        oneDark,
        keymap.of([indentWithTab]),
        EditorView.theme({
          "&": { height: "100%", fontSize: "14px" },
          ".cm-scroller": { overflow: "auto", fontFamily: "'Fira Code', 'Courier New', monospace" },
        }),
      ],
      parent: this.hasHostTarget ? this.hostTarget : this.element,
    })

    // Expose the view on the element for other controllers
    this.element._editorView = this._view
    this.element._editorController = this
  }

  disconnect() {
    this._view?.destroy()
  }

  getValue() {
    return this._view?.state.doc.toString() || ""
  }

  setValue(code) {
    if (!this._view) return
    this._view.dispatch({
      changes: {
        from: 0,
        to: this._view.state.doc.length,
        insert: code,
      },
    })
  }
}
